var _defs, _g, _filter, _filter2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlatypus(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "main-canvas",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsSvgjs: "http://svgjs.com/svgjs",
    style: {
      backgroundColor: "white"
    },
    viewBox: "-3212.15 608.71 1402.07 139.92",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "SvgjsDefs1002"
  }, /*#__PURE__*/React.createElement("script", {
    xmlns: "http://www.w3.org/1999/xhtml"
  }, "function $(id) { return document.getElementById(id) }"), /*#__PURE__*/React.createElement("radialGradient", {
    id: "oBWeJhIC",
    r: 2,
    fx: 0.39713986860137906,
    fy: 0.40955578187091113,
    cx: 0.39713986860137906,
    cy: 0.40955578187091113,
    gradientTransform: "translate(0.39713986860137906, 0.40955578187091113) scale(1, 5.666360219290363) translate(-0.39713986860137906, -0.40955578187091113)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffffffff",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00000000",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "LCOyXY6x",
    r: 2,
    fx: 0.6680708074044184,
    fy: 0.38438869508716467,
    cx: 0.6680708074044184,
    cy: 0.38438869508716467,
    gradientTransform: "translate(0.6680708074044184, 0.38438869508716467) scale(1, 5.666360219290363) translate(-0.6680708074044184, -0.38438869508716467)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53599aff",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00000000",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "sketchGroup",
    transform: "matrix(1,0,0,1,347,301)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    depth: 1,
    transform: "matrix(1 0 0 1 -3844.0840750967773 187.6760746038268)",
    separatedTransform: "-3844.0840750967773,187.6760746038268,1,1,0,0,1,1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath1141",
    d: "M297.19 66.14 C 263.90 66.99,253.19 67.63,206.69 71.59 C 179.54 73.91,168.31 75.31,166.12 76.67 C 165.60 76.99,165.19 86.47,165.19 98.18 C 165.19 119.12,165.19 119.12,173.44 119.13 C 177.98 119.14,230.50 117.97,290.16 116.54 C 368.51 114.66,398.73 114.24,399.00 115.03 C 399.20 115.64,399.66 115.95,400.03 115.72 C 400.65 115.34,399.42 71.01,398.77 70.36 C 398.60 70.20,394.92 69.66,390.58 69.16 C 386.24 68.67,381.34 67.71,379.69 67.03 C 375.84 65.45,339.68 65.06,297.19 66.14 ",
    fillOpacity: 1,
    fill: "#6a8e7f",
    transform: "matrix(2.063365726840419,0,0,2.063365726840419,0,0)",
    potraced: "yes",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath1139",
    d: "M142.19 100.87 C 137.10 103.42,136.64 110.64,141.43 112.82 C 145.21 114.54,166.75 112.83,169.21 110.61 C 171.59 108.45,171.78 104.40,169.64 101.34 C 167.53 98.33,147.95 98.00,142.19 100.87 ",
    fillOpacity: 1,
    fill: "#ffa500",
    transform: "matrix(2.063365726840419,0,0,2.063365726840419,0,0)",
    potraced: "yes",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath1142",
    d: "M439.69 86.69 C 403.25 89.66,397.95 90.80,399.27 95.38 C 399.78 97.16,400.19 101.87,400.19 105.86 C 400.19 109.86,400.53 113.12,400.94 113.12 C 401.36 113.12,422.75 113.81,448.49 114.65 C 499.93 116.33,497.19 116.52,497.19 111.26 C 497.19 109.20,497.68 107.03,498.28 106.44 C 498.87 105.84,499.60 102.67,499.90 99.39 C 501.17 85.37,488.52 82.70,439.69 86.69 ",
    fillOpacity: 1,
    fill: "#a26769",
    filter: "url(#bold-animate-remix-34)",
    transform: "matrix(2.063365726840419,0,0,2.063365726840419,0,0)",
    potraced: "yes",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath1068",
    d: "M192.30 99.06 C 190.91 99.91,191.40 103.14,192.91 103.11 C 195.43 103.06,196.68 101.19,195.19 99.69 C 194.24 98.74,193.19 98.51,192.30 99.06 ",
    fillOpacity: 1,
    fill: "#000000",
    potraced: "yes",
    transform: "matrix(2.063365726840419,0,0,2.063365726840419,0,0)",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath1069",
    d: "M401.19 96.99 C 401.19 97.46,403.25 98.63,405.76 99.59 C 408.27 100.55,412.35 102.89,414.84 104.79 C 417.67 106.95,420.17 108.10,421.53 107.86 C 423.58 107.50,423.55 107.42,421.04 106.36 C 419.58 105.75,418.08 104.76,417.72 104.16 C 416.10 101.55,401.19 95.08,401.19 96.99 ",
    fillOpacity: 1,
    fill: "#000000",
    potraced: "yes",
    transform: "matrix(2.063365726840419,0,0,2.063365726840419,0,0)",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath1070",
    d: "M413.61 97.87 C 407.30 102.75,401.19 109.10,401.19 110.79 C 401.19 113.05,402.59 112.25,404.93 108.64 C 406.16 106.74,410.08 103.03,413.64 100.40 C 419.72 95.91,421.34 94.12,419.33 94.12 C 418.86 94.12,416.28 95.81,413.61 97.87 ",
    fillOpacity: 1,
    fill: "#000000",
    potraced: "yes",
    transform: "matrix(2.063365726840419,0,0,2.063365726840419,0,0)",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath1071",
    d: "M418.19 94.87 C 418.19 95.29,420.13 96.65,422.50 97.91 C 424.88 99.17,429.17 102.26,432.05 104.78 C 434.93 107.30,437.60 109.04,437.99 108.64 C 438.85 107.76,431.32 100.87,425.25 96.97 C 420.89 94.18,418.19 93.38,418.19 94.87 ",
    fillOpacity: 1,
    fill: "#000000",
    potraced: "yes",
    transform: "matrix(2.063365726840419,0,0,2.063365726840419,0,0)",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath1072",
    d: "M459.47 99.58 C 459.47 100.90,449.86 110.22,445.97 112.66 C 443.25 114.38,443.17 114.55,445.19 114.55 C 447.72 114.56,456.72 106.95,460.13 101.92 C 461.89 99.33,462.07 98.56,460.94 98.56 C 460.13 98.56,459.47 99.02,459.47 99.58 ",
    fillOpacity: 1,
    fill: "#000000",
    potraced: "yes",
    transform: "matrix(1.9601974404983946,0,0,1.9601974404983946,0,0)",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath1073",
    d: "M460.47 98.48 C 460.47 99.18,462.27 101.79,464.46 104.28 C 466.66 106.78,469.69 110.78,471.21 113.18 C 472.73 115.59,474.52 117.55,475.20 117.55 C 475.87 117.56,473.91 113.99,470.85 109.64 C 464.83 101.10,460.47 96.40,460.47 98.48 ",
    fillOpacity: 1,
    fill: "#000000",
    potraced: "yes",
    transform: "matrix(1.9601974404983946,0,0,1.9601974404983946,0,0)",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath1074",
    d: "M478.30 101.34 C 478.12 101.78,475.95 103.31,473.47 104.75 C 467.68 108.13,460.77 114.15,461.66 115.06 C 462.03 115.44,463.38 114.75,464.66 113.53 C 465.93 112.30,470.01 109.31,473.72 106.88 C 477.43 104.45,480.47 102.03,480.47 101.51 C 480.47 100.36,478.78 100.23,478.30 101.34 ",
    fillOpacity: 1,
    fill: "#000000",
    potraced: "yes",
    transform: "matrix(1.9601974404983946,0,0,1.9601974404983946,0,0)",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath1075",
    d: "M480.02 99.48 C 479.70 99.99,480.42 100.72,481.61 101.10 C 482.79 101.48,486.61 104.43,490.09 107.67 C 495.76 112.94,498.47 114.66,498.47 112.98 C 498.47 112.20,487.80 102.47,484.58 100.31 C 481.60 98.32,480.82 98.18,480.02 99.48 ",
    fillOpacity: 1,
    fill: "#000000",
    potraced: "yes",
    transform: "matrix(1.9601974404983946,0,0,1.9601974404983946,0,0)",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath1076",
    d: "M490.97 105.53 C 486.57 108.80,482.41 111.49,481.72 111.51 C 481.03 111.54,480.47 112.01,480.47 112.56 C 480.47 115.01,499.16 103.62,500.30 100.47 C 501.01 98.54,498.70 99.79,490.97 105.53 ",
    fillOpacity: 1,
    fill: "#000000",
    potraced: "yes",
    transform: "matrix(1.9601974404983946,0,0,1.9601974404983946,0,0)",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath1077",
    d: "M499.47 100.56 C 499.47 101.11,499.91 101.56,500.43 101.56 C 500.96 101.56,504.28 104.26,507.81 107.56 C 515.04 114.32,519.01 115.78,512.92 109.44 C 506.23 102.46,499.47 98.00,499.47 100.56 ",
    fillOpacity: 1,
    fill: "#000000",
    potraced: "yes",
    transform: "matrix(1.9601974404983946,0,0,1.9601974404983946,0,0)",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath1078",
    d: "M518.47 100.42 C 509.66 106.13,502.69 112.07,503.65 113.05 C 504.02 113.43,507.01 111.52,510.28 108.79 C 513.56 106.07,518.77 102.39,521.86 100.62 C 524.94 98.86,527.47 96.99,527.47 96.48 C 527.47 94.86,526.15 95.44,518.47 100.42 ",
    fillOpacity: 1,
    fill: "#000000",
    potraced: "yes",
    transform: "matrix(1.9601974404983946,0,0,1.9601974404983946,0,0)",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath1140",
    d: "M231.94 123.42 C 229.06 124.32,222.47 129.82,222.47 131.31 C 222.47 133.02,242.56 133.07,244.27 131.36 C 247.31 128.31,245.73 123.56,241.72 123.71 C 239.66 123.79,237.07 123.61,235.97 123.32 C 234.87 123.02,233.06 123.07,231.94 123.42 M234.14 126.22 C 233.77 126.59,233.17 126.59,232.80 126.22 C 232.44 125.86,232.74 125.56,233.47 125.56 C 234.20 125.56,234.50 125.86,234.14 126.22 ",
    fillOpacity: 1,
    fill: "#ffa500",
    transform: "matrix(1.9601974404983946,0,0,1.9601974404983946,0,0)",
    potraced: "yes",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath1080",
    d: "M329.79 123.93 C 323.01 127.09,322.63 127.57,325.04 129.99 C 327.04 131.99,327.50 131.97,342.47 129.20 C 355.40 126.81,357.42 125.61,354.46 122.04 C 352.21 119.33,337.21 120.48,329.79 123.93 ",
    fillOpacity: 1,
    fill: "#e1b44d",
    potraced: "yes",
    transform: "matrix(1.9601974404983946,0,0,1.9601974404983946,0,0)",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath1081",
    d: "M0 0 ",
    fillOpacity: 1,
    fill: "#7a9cbe",
    potraced: "yes",
    transform: "matrix(1.9601974404983946,0,0,1.9601974404983946,0,0)",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath1082",
    d: "M0 0 ",
    fillOpacity: 1,
    fill: "#306a6e",
    potraced: "yes",
    transform: "matrix(1.9601974404983946,0,0,1.9601974404983946,0,0)",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath1083",
    d: "M0 0 ",
    fillOpacity: 1,
    fill: "#8f7272",
    potraced: "yes",
    filter: "url(#water)",
    transform: "matrix(3.446197472741701,0,0,3.446197472741701,0,0)",
    opacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer2",
    depth: 1,
    transform: "matrix(1 0 0 1 0 0)",
    separatedTransform: "0,0,1,1,0,0,1,1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath1144",
    d: "M-1127.79 148.44 C -1129.99 149.22,-1132.46 150.69,-1133.29 151.69 C -1141.74 162.01,-1140.41 161.64,-1146.90 155.46 C -1153.09 149.56,-1156.45 148.61,-1158.66 152.15 C -1160.62 155.28,-1149.93 165.94,-1144.83 165.94 C -1140.34 165.94,-1137.29 178.30,-1137.29 196.48 C -1137.29 201.27,-1137.04 201.94,-1135.29 201.94 C -1132.09 201.94,-1133.41 172.75,-1136.85 167.28 C -1138.09 165.32,-1137.99 165.08,-1135.77 164.52 C -1134.43 164.19,-1130.57 161.44,-1127.19 158.42 C -1123.80 155.41,-1120.52 152.94,-1119.88 152.94 C -1117.69 152.94,-1114.37 149.90,-1114.94 148.41 C -1115.67 146.51,-1122.38 146.53,-1127.79 148.44 M-1128.29 153.38 C -1128.29 153.62,-1128.81 154.14,-1129.44 154.53 C -1130.16 154.97,-1130.33 154.81,-1129.88 154.09 C -1129.17 152.94,-1128.29 152.54,-1128.29 153.38 ",
    fillOpacity: 0.88,
    fill: "#6a8e7f",
    filter: "url(#bold-animate-remix-34)",
    transform: "matrix(2.1719639229898346,0,0,2.1719639229898346,0,0)",
    potraced: "yes",
    opacity: 0.88
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath1146",
    d: "M-1065.24 156.47 C -1073.56 160.80,-1073.56 160.80,-1076.17 158.88 C -1081.40 155.05,-1091.29 153.26,-1091.29 156.14 C -1091.29 158.32,-1084.50 163.81,-1080.99 164.46 C -1077.33 165.15,-1077.33 165.15,-1077.06 182.29 C -1076.83 196.74,-1076.55 199.44,-1075.29 199.44 C -1074.02 199.44,-1073.75 196.74,-1073.52 182.28 C -1073.24 165.12,-1073.24 165.12,-1066.02 162.95 C -1056.93 160.22,-1054.29 158.54,-1054.29 155.52 C -1054.29 151.69,-1056.43 151.88,-1065.24 156.47 ",
    fillOpacity: 0.88,
    fill: "#6a8e7f",
    filter: "url(#bold-animate-remix-34)",
    transform: "matrix(2.1719639229898346,0,0,2.1719639229898346,0,0)",
    potraced: "yes",
    opacity: 0.88
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPolyline1123",
    d: "M0 0 ",
    opacity: 0.88,
    transform: "matrix(6.377594406811856,0,0,6.377594406811856,0,0)",
    filter: "url(#bold-animate-remix-34)",
    fill: "#c3d7af",
    fillOpacity: 0.88,
    potraced: "yes"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath1156",
    d: "M-1919.36 262.44 C -1936.10 264.63,-1923.58 281.20,-1898.54 290.00 C -1894.14 291.54,-1890.44 292.87,-1890.31 292.94 C -1889.32 293.54,-1887.82 311.25,-1887.47 326.46 C -1886.55 366.93,-1885.77 376.96,-1883.54 376.96 C -1881.69 376.96,-1881.55 376.32,-1881.63 368.46 C -1881.79 353.98,-1884.02 305.29,-1884.83 298.77 C -1885.91 290.07,-1884.58 289.13,-1863.19 283.43 C -1842.26 277.86,-1829.00 262.90,-1845.08 262.99 C -1852.57 263.03,-1873.61 274.05,-1882.72 282.70 C -1886.70 286.48,-1888.45 285.86,-1889.88 280.17 C -1892.84 268.44,-1905.76 260.66,-1919.36 262.44 M-1904.04 268.99 C -1902.66 269.69,-1900.41 271.55,-1899.04 273.11 C -1897.56 274.79,-1897.36 275.26,-1898.54 274.27 C -1899.64 273.35,-1902.63 271.71,-1905.18 270.61 C -1910.24 268.44,-1913.06 265.70,-1908.91 266.98 C -1907.61 267.38,-1905.41 268.29,-1904.04 268.99 M-1920.11 271.77 C -1920.07 272.21,-1920.49 272.30,-1921.04 271.96 C -1921.59 271.62,-1922.01 270.36,-1921.97 269.15 C -1921.90 266.97,-1920.34 269.17,-1920.11 271.77 M-1846.02 270.93 C -1847.48 272.70,-1858.78 278.46,-1860.78 278.46 C -1863.15 278.46,-1856.71 273.69,-1851.45 271.56 C -1845.48 269.14,-1844.43 269.02,-1846.02 270.93 M-1869.04 278.96 C -1869.72 279.78,-1870.79 280.45,-1871.41 280.43 C -1872.03 280.41,-1871.67 279.74,-1870.60 278.93 C -1868.10 277.04,-1867.46 277.05,-1869.04 278.96 M-1892.54 286.46 C -1892.20 287.01,-1892.37 287.46,-1892.92 287.46 C -1893.47 287.46,-1894.20 287.01,-1894.54 286.46 C -1894.88 285.91,-1894.71 285.46,-1894.16 285.46 C -1893.61 285.46,-1892.88 285.91,-1892.54 286.46 ",
    fillOpacity: 0.88,
    fill: "#6a8e7f",
    filter: "url(#bold-animate-remix-34)",
    transform: "matrix(1.1736426158268662,0,0,1.1736426158268662,0,0)",
    potraced: "yes",
    opacity: 0.88
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPolyline1179",
    d: "M-2086.57 268.51 C -2091.33 270.68,-2099.53 278.71,-2102.10 283.72 C -2103.93 287.28,-2103.93 287.28,-2112.86 282.94 C -2122.96 278.02,-2129.58 276.81,-2135.56 278.82 C -2147.65 282.86,-2129.61 297.65,-2112.57 297.65 C -2106.06 297.65,-2104.51 306.32,-2103.77 347.15 C -2103.59 357.42,-2103.44 358.15,-2101.57 358.15 C -2098.83 358.15,-2099.52 316.11,-2102.59 296.40 C -2102.89 294.51,-2102.59 293.65,-2101.63 293.65 C -2097.57 293.65,-2078.12 282.48,-2075.16 278.45 C -2068.13 268.90,-2074.76 263.14,-2086.57 268.51 M-2084.13 273.93 C -2087.12 275.74,-2090.25 277.61,-2091.07 278.09 C -2091.90 278.58,-2091.45 277.72,-2090.07 276.18 C -2087.56 273.38,-2082.82 270.76,-2080.13 270.69 C -2079.34 270.67,-2081.14 272.13,-2084.13 273.93 M-2088.93 282.68 C -2091.16 284.53,-2093.07 285.23,-2093.07 284.18 C -2093.07 283.69,-2087.94 280.73,-2087.07 280.72 C -2086.80 280.72,-2087.64 281.60,-2088.93 282.68 M-2118.94 291.16 C -2110.97 293.60,-2110.82 293.69,-2115.75 293.24 C -2120.29 292.82,-2131.07 288.50,-2131.07 287.10 C -2131.07 286.81,-2130.22 287.03,-2129.19 287.59 C -2128.15 288.14,-2123.54 289.75,-2118.94 291.16 ",
    opacity: 0.88,
    transform: "matrix(1.2354132798177466,0,0,1.2354132798177466,0,0)",
    filter: "url(#bold-animate-remix-34)",
    fill: "#6a8e7f",
    fillOpacity: 0.88,
    potraced: "yes"
  })))), _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "water"
  }, /*#__PURE__*/React.createElement("feTurbulence", {
    baseFrequency: "0.01 0.05",
    numOctaves: 1,
    result: "turbulence",
    seed: 0,
    stitchTiles: "noStitch",
    filtername: "feTurbulence"
  }), /*#__PURE__*/React.createElement("feDisplacementMap", {
    animation: "{\"scale\":\"{\\\\\\\\\"attributeName\\\\\\\\\":\\\\\\\\\"scale\\\\\\\\\",\\\\\\\\\"dur\\\\\\\\\":\\\\\\\\\"3\\\\\\\\\",\\\\\\\\\"values\\\\\\\\\":\\\\\\\\\"200;100;50;100;200\\\\\\\\\"}\"}",
    in: "SourceGraphic",
    in2: "turbulence",
    result: "displacementMap",
    scale: 200,
    filtername: "feDisplacementMap"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "scale",
    dur: 3,
    values: "200;100;50;100;200",
    attributeType: "XML",
    repeatCount: "indefinite"
  })))), _filter2 || (_filter2 = /*#__PURE__*/React.createElement("filter", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "bold-animate-remix-34"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    operator: "dilate",
    radius: 5,
    in: "SourceGraphic",
    result: "jXlRSb",
    animation: "{\"radius\":\"{\\\\\\\\\"attributeName\\\\\\\\\":\\\\\\\\\"radius\\\\\\\\\",\\\\\\\\\"dur\\\\\\\\\":\\\\\\\\\"3.2\\\\\\\\\",\\\\\\\\\"values\\\\\\\\\":\\\\\\\\\"2;1;1;2;2;2\\\\\\\\\"}\"}",
    filtername: "feMorphology"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "radius",
    dur: 3.2,
    values: "2;1;1;2;2;2",
    attributeType: "XML",
    repeatCount: "indefinite"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlatypus);
export default __webpack_public_path__ + "static/media/platypus.a91a961894171b699b01beadcb4669f5.svg";
export { ForwardRef as ReactComponent };